import { render, staticRenderFns } from "./futbol.vue?vue&type=template&id=9b5e58a8&scoped=true&"
import script from "./futbol.vue?vue&type=script&lang=js&"
export * from "./futbol.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b5e58a8",
  null
  
)

export default component.exports